import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'
import { queryConfigItem, queryPromoter, queryKycStatus } from 'store/siteConfig'
import queryString from 'query-string'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const MERCHANT_PROMOTION_INVITEE = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    SUBMIT_REQUEST: null,
    SUBMIT_SUCCESS: null,
    QUERY_RESULT_REQUEST: null,
    QUERY_RESULT_SUCCESS: null,
    SHOW_PAGE: null,
    SET_USER_TYPE: null,
    JOIN_REQUEST: null,
    JOIN_SUCCESS: null,
    QUERY_RECEIVE_STATUS_REQUEST: null,
    QUERY_RECEIVE_STATUS_SUCCESS: null,
    RECEIVE_REQUEST: null,
    RECEIVE_SUCCESS: null
  },
  'MERCHANT_PROMOTION_INVITEE'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/v1/auth/invite-code/activity/status/query',
        body: {
          ...data,
          source: window.location.pathname
        },
        method: 'POST',
        requestAction: MERCHANT_PROMOTION_INVITEE.INIT_REQUEST,
        successAction: MERCHANT_PROMOTION_INVITEE.INIT_SUCCESS,
        success: function(result) {
          dispatch({
            type: MERCHANT_PROMOTION_INVITEE.SHOW_PAGE
          })
          dispatch(queryConfigItem({ itemKey: 'PROMOTE_VOUCHER_WEEKLY' }))
        }
      })
    )
  }
}

export function query(data) {
  return (dispatch) => {
    dispatch(queryPromoter()).then((res) => {
      console.log(res.payload)
      const { commandData } = res.payload
      if (_.get(commandData, 'bizData.isPromoter') === 'Y') {
        // 非推广员进入被邀请人流程
        return dispatch(
          replace(
            queryString.stringifyUrl({
              url: '/merchant/promotion/promoter',
              query: data
            })
          )
        )
      }
      return dispatch(queryKycStatus()).then((resData) => {
        console.log(resData.payload)
        const { kycStatus } = resData.payload
        if (kycStatus === 'KYC_FINISH') { // 已kyc参加商超促销活动
          dispatch(setUserType({ userType: 'OLD' }))
          dispatch(join())
        } else {
          dispatch(setUserType({ userType: 'NEW' }))
          dispatch(init(data))
        }
      })
    })
  }
}

export function submit(data, callback) { // 补录邀请码
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/v1/auth/invite-code/activity/voucher/get',
        body: {
          ...data,
          source: window.location.pathname
        },
        method: 'POST',
        requestAction: MERCHANT_PROMOTION_INVITEE.SUBMIT_REQUEST,
        successAction: MERCHANT_PROMOTION_INVITEE.SUBMIT_SUCCESS,
        success: function(result) {
          Toast.hide()
          typeof callback === 'function' && callback(result.commandData)
        }
      })
    )
  }
}

export function queryResult() {
  // 查询新用户领取结果
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/national-day/v1/auth/voucher/query-receive-result',
        method: 'POST',
        body: {
          sceneCode: 'MERCHANT_PROMOTERS'
        },
        requestAction: MERCHANT_PROMOTION_INVITEE.QUERY_RESULT_REQUEST,
        successAction: MERCHANT_PROMOTION_INVITEE.QUERY_RESULT_SUCCESS,
        success: function(result) {
          console.log(result)
          const { bizData = {} } = result.commandData
          if (bizData.needRetry) {
            // kyc审核中，重试
            setTimeout(() => {
              dispatch(queryResult())
            }, 2000)
          } else {
            Toast.hide()
          }
        }
      })
    )
  }
}

export function setUserType(data) {
  return (dispatch) => {
    dispatch({
      type: MERCHANT_PROMOTION_INVITEE.SET_USER_TYPE,
      payload: data
    })
  }
}

export function join(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/activity/detail',
        method: 'POST',
        body: {
          scenesCode: 'SUPER_MARKET'
        },
        requestAction: MERCHANT_PROMOTION_INVITEE.JOIN_REQUEST,
        successAction: MERCHANT_PROMOTION_INVITEE.JOIN_SUCCESS,
        success: function(result) {
          dispatch(queryConfigItem({ itemKey: 'PROMOTE_VOUCHER_WEEKLY' }))
          const { bizData = {} } = result.commandData
          const { activityStatus, activityCode } = bizData
          if (activityStatus === 'N') {
            dispatch({
              type: MERCHANT_PROMOTION_INVITEE.SHOW_PAGE
            })
          } else {
            activityCode && dispatch(receive({ activityCode }))
          }
        }
      })
    )
  }
}

export function queryReceiveStatus(data) {
  // 查询领取状态
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/voucher/receive-status',
        method: 'POST',
        body: data,
        requestAction: MERCHANT_PROMOTION_INVITEE.QUERY_RECEIVE_STATUS_REQUEST,
        successAction: MERCHANT_PROMOTION_INVITEE.QUERY_RECEIVE_STATUS_SUCCESS,
        success: function(result) {
          dispatch(receive(data))
        }
      })
    )
  }
}

export function receive(data) {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/voucher/get',
        method: 'POST',
        body: data,
        requestAction: MERCHANT_PROMOTION_INVITEE.RECEIVE_REQUEST,
        successAction: MERCHANT_PROMOTION_INVITEE.RECEIVE_SUCCESS,
        success: function(result) {
          dispatch({
            type: MERCHANT_PROMOTION_INVITEE.SHOW_PAGE
          })
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MERCHANT_PROMOTION_INVITEE.INIT_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_INVITEE.INIT_SUCCESS]: (state, action) => {
    let { commandData = {} } = action.payload
    const tipText = _.get(commandData, 'tipsInfo.tipText')
    if (
      tipText &&
      (tipText.indexOf('Activate your account') !== -1 ||
        tipText.indexOf('Please enter') !== -1)
    ) {
      // 初始化查询nokyc不弹窗
      commandData = _.omit(commandData, ['tipsInfo'])
    }
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [MERCHANT_PROMOTION_INVITEE.SUBMIT_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_INVITEE.SUBMIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [MERCHANT_PROMOTION_INVITEE.QUERY_RESULT_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_INVITEE.QUERY_RESULT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [MERCHANT_PROMOTION_INVITEE.SHOW_PAGE]: (state, action) =>
    Object.assign({}, state, { showPage: true }),
  [MERCHANT_PROMOTION_INVITEE.SET_USER_TYPE]: (state, action) =>
    Object.assign({}, state, action.payload),
  [MERCHANT_PROMOTION_INVITEE.JOIN_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_INVITEE.JOIN_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [MERCHANT_PROMOTION_INVITEE.QUERY_RECEIVE_STATUS_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_INVITEE.QUERY_RECEIVE_STATUS_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    state.bizData = Object.assign({}, state.bizData, commandData.bizData)
    return Object.assign({}, state, { tipsInfo: commandData.tipsInfo })
  },
  [MERCHANT_PROMOTION_INVITEE.RECEIVE_REQUEST]: (state, action) => state,
  [MERCHANT_PROMOTION_INVITEE.RECEIVE_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    if (_.get(commandData, 'bizData.amount')) {
      commandData.bizData.receiveStatus = 'Y' // 首次领取成功
      commandData.tipsInfo = {}
    }
    return Object.assign({}, state, action.payload, { ...commandData })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'merchantPromotionInvitee',
    reducerMap: {
      merchantPromotionInviteeState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
